class YcHeroVideo extends HTMLElement {
    constructor(){
        super()


        this.video = this.querySelector('video')
        this.mute = this.mute.bind(this)
        this.unmute = this.unmute.bind(this)
        this.load = this.load.bind(this)
        this.resize = this.resize.bind(this)

        this.muteButton = this.querySelector('.sound-on')
        this.unMuteButton = this.querySelector('.sound-off')


        this.muteButton.addEventListener('click',this.mute)
        this.unMuteButton.addEventListener('click',this.unmute)


        if(this.attributes.portrait){
            this.ratio = 'portrait'
        }else{
            this.ratio = 'landscape'
        }
    
        this.load()
        window.addEventListener('resize',this.resize)


        this.resizeTimeout = false;

    }


    resize(){
        clearTimeout(this.resizeTimeout)
        this.resizeTimeout = setTimeout(this.load,300)
    }

    

    load(){

        if(this.ratio==='portrait'){
            if(window.innerWidth <=750){
                if(this.video.src !==  this.video.dataset.src){
                    this.video.setAttribute('src',this.video.dataset.src)
                }
            }else{
                
                this.video.setAttribute('src','')
            }
        }

        if(this.ratio==='landscape'){
            if(window.innerWidth >750){
                if(this.video.src !==  this.video.dataset.src){
                    this.video.setAttribute('src',this.video.dataset.src)
                }
            }else{
                this.video.setAttribute('src','')
            }
        }
        
    }   

    mute(){
        this.video.muted = true;
        this.classList.remove('unmuted')
        console.log('mute')

    }

    unmute(){
        this.video.muted = false;
        this.classList.add('unmuted')
        console.log('unmute')


    }
  }
  
  customElements.define('yc-hero-video', YcHeroVideo);